import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { Message } from 'types/chat';
import { parse } from 'cookie';
import env from '.env.json';

export const speak = async (data) => {
  return await apiRequest(`/api/chats/tts`, 'post', data, false, env.URL_API_NODE);
};

export const chatComplete = async (text: string) => {
  const result = await apiRequest(`/api/chats/completes`, 'post', { text }, false, env.URL_API_NODE) as ResultAPI;

  return result.data as string;
};

export const getConversation = async (roomId: string) => {
  if (roomId) {
    const result = await apiRequest(`/api/conversations/${roomId}`, 'get') as ResultAPI;
    return result.data;
  }
}

export const storeMessage = async (message: Message) => {
  const cookies = parse(document.cookie || '');
  const deviceId = cookies?.device_id

  const result = await apiRequest(`/api/conversations`, 'post', {
    ...message,
    room_id: deviceId,
  }) as ResultAPI;

  return result.data;
}
